var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoftwareVersionChangedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "update_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_936",
    "data-name": "Rectangle 936",
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M11,8.75v3.68a1.012,1.012,0,0,0,.49.86l3.12,1.85a.758.758,0,0,0,1.03-.26.749.749,0,0,0-.26-1.03l-2.87-1.71V8.74A.769.769,0,0,0,11.75,8,.755.755,0,0,0,11,8.75ZM21,9.5V4.21a.5.5,0,0,0-.85-.35L18.37,5.64a9,9,0,1,0,2.56,7.48,1,1,0,0,0-1-1.12.984.984,0,0,0-.98.86A7.015,7.015,0,0,1,11.9,19,7.1,7.1,0,0,1,5,12.1,7,7,0,0,1,16.95,7.05L14.86,9.14a.5.5,0,0,0,.35.86H20.5A.5.5,0,0,0,21,9.5Z",
    fill: "#62b0dc"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareVersionChangedIcon);
export default __webpack_public_path__ + "static/media/SoftwareVersionChangedIcon.e5ba36076b62c88565bb92db43629cfe.svg";
export { ForwardRef as ReactComponent };